var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 90,
    viewBox: "0 0 97 90",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3902 32.6904C49.0944 28.2891 48.804 23.9102 50.8594 19.6654C53.585 13.9907 58.2097 10.5277 64.2419 8.87447C67.5484 7.95848 70.9219 7.24354 74.2508 6.34989C76.5966 5.72433 78.5627 4.49557 79.8585 2.3508C80.417 1.39012 81.2213 1.055 81.6234 2.3508C83.5001 8.71809 85.2204 15.1301 84.014 21.8548C81.7351 34.433 70.7655 45.7601 53.2052 35.7064",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3783 16.4482C73.3783 16.4482 71.3452 24.8933 59.8394 28.1551C48.3336 31.4169 44.0664 41.2025 44.0664 41.2025C44.0664 41.2025 41.9886 44.3526 42.8599 52.2838",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4473 39.08C41.4134 35.9298 42.5975 32.5563 41.9272 28.7806C41.0559 23.7314 38.2409 20.0227 33.929 17.4088C31.5385 15.9566 29.1033 14.6832 26.7127 13.2533C25.0371 12.2479 23.7637 10.8404 23.2498 8.89674C23.0264 8.02543 22.4679 7.57861 21.887 8.51694C19.0497 13.0969 16.3017 17.7663 15.7655 23.2846C14.7825 33.6286 20.8146 44.8887 36.61 40.8449",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.591 46.9442C42.591 46.9442 41.4069 38.3651 33.1182 33.2936C24.8296 28.2221 25.0977 21.1846 25.0977 21.1846",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9892 79.2054L39.0625 72.8604L38.638 70.8273C37.655 66.225 34.8623 62.2259 30.8632 59.7013C28.8972 58.4726 26.6183 57.8023 24.2948 57.8023C22.2841 57.8023 20.4745 56.6182 19.6925 54.7863L18.9106 52.9542C17.6148 49.9605 14.2412 48.419 11.0911 49.402C10.2198 49.6701 9.75061 50.6307 10.041 51.4797L11.739 56.5065C12.655 59.1875 14.2412 61.6227 16.3637 63.5217L22.0384 68.6379",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4413 89.5718L28.3412 84.3216C27.0678 81.1268 24.7219 78.4459 21.7505 76.7702L14.6236 72.7488C10.0213 70.1349 6.75946 65.6666 5.66473 60.461L0.794315 37.092C0.54856 35.9749 1.30817 34.8802 2.44758 34.7014C5.79878 34.2099 8.92657 36.4664 9.50745 39.8176L11.2054 49.5138",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4375 79.2054L57.3642 72.8604L57.7887 70.8273C58.7717 66.225 61.5644 62.2259 65.5635 59.7013C67.5295 58.4726 69.8084 57.8023 72.1319 57.8023C74.1426 57.8023 75.9522 56.6182 76.7342 54.7863L77.5161 52.9542C78.8119 49.9605 82.1855 48.419 85.3356 49.402C86.2069 49.6701 86.6761 50.6307 86.3857 51.4797L84.6877 56.5065C83.7717 59.1875 82.1855 61.6227 80.0631 63.5217L74.3883 68.6379",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9658 89.5718L68.0659 84.3216C69.3394 81.1268 71.6852 78.4459 74.679 76.7702L81.8059 72.7488C86.4082 70.1349 89.67 65.6666 90.7647 60.461L95.6352 37.092C95.8809 35.9749 95.1213 34.8802 93.9819 34.7014C90.6307 34.2099 87.5029 36.4664 86.922 39.8176L85.2241 49.5138",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoIcon);
export default __webpack_public_path__ + "static/media/eco-icon.0a590236.svg";
export { ForwardRef as ReactComponent };